import { Capacitor } from '@capacitor/core'
import { Haptics, ImpactStyle } from '@capacitor/haptics'

/**
 * Retour haptique, avec parcimonie.
 *
 * HIG `feedback` : « use multiple feedback methods … color + text + sound +
 * haptics ». L'app n'avait que du visuel (`material-press`, la bulle de la tab
 * bar, la coche d'un menu). On ajoute la troisième modalité sur les **deux
 * gestes décisifs**, et seulement eux :
 *
 * - choisir une compétition (`CompetitionsView`, `FeaturedCarousel`) — le geste
 *   qui change l'univers entier de l'app, jusqu'à sa couleur ;
 * - changer d'onglet (`TabBarItem`) — comme une tab bar native.
 *
 * Pas sur un défilement, pas sur une pastille de filtre, pas sur l'ouverture
 * d'un menu : le HIG est explicite (« overusing haptics … can be distracting »),
 * et un retour sur chaque tap finit par ne plus rien vouloir dire.
 *
 * **Natif seulement.** La même `dist/` s'installe en PWA, où `Haptics` retombe
 * sur `navigator.vibrate` — une vibration franche là où iOS donne une
 * impulsion, et une API que Safari n'implémente pas. On teste donc la
 * plateforme plutôt que la disponibilité : sur le web, on ne vibre pas.
 *
 * Tout échec est **avalé** : un retour haptique refusé (réglage système,
 * batterie faible, appareil sans Taptic Engine) ne doit jamais empêcher la
 * navigation qu'il accompagne. D'où le `void` + `catch` sur chaque appel, et
 * aucune de ces fonctions n'est à `await`.
 */
const enabled = Capacitor.isNativePlatform()

/** Le geste qui change d'univers : une impulsion qu'on sent passer. */
export function hapticSelection(): void {
  if (!enabled) return
  void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {})
}

/** Le changement d'onglet : le plus léger des trois styles. */
export function hapticTab(): void {
  if (!enabled) return
  void Haptics.impact({ style: ImpactStyle.Light }).catch(() => {})
}
